export enum PRODUCT {
    "ENGAGEMENT_PREFERENCES" = "ENGAGEMENT_PREFERENCES",
}

export enum ACTION {
    "FOLLOW" = "FOLLOW",
}
  
export enum RESOURCE {
    "TOPIC" = "Topic",
}

export enum DATA_ORIGIN { 
    "HOME_FEED" = "HOME_FEED",
}
